import { lazy } from 'react';
import { PrivateRoute } from '../../components/PrivateRoute/PrivateRoute';
import { baseUrls } from '../../constants/urls';
import { Redirect, Route } from 'react-router-dom';
const NewCashMovementRequest = lazy(() => import('./pages/NewCashMovementRequest/NewCashMovementRequest'));
const CashMovementRequests = lazy(() => import('./pages/CashMovementRequests/CashMovementRequests'));
const CashMovementRequestCreated = lazy(() => import('./pages/CashMovementRequestCreated/CashMovementRequestCreated'));
const CashMovementRequest = lazy(() => import('./pages/CashMovementRequest/CashMovementRequest'));
const CreateBulkCashMovementRequest = lazy(() => import('./pages/CreateBulkCashMovementRequest/CreateBulkCashMovementRequest'));
const CmrRoutes = [
  <PrivateRoute path={baseUrls.cashMovementRequests} exact={true} permissions={['cashMovementRequestsEnabled', 'achPullRequestsEnabled']} key="cashMovements">
    <CashMovementRequests />
  </PrivateRoute>,
  <Route path="/cash-movement-requests/new" exact={true} key="cashMovementNewRedirect">
    <Redirect to={baseUrls.cashMovementNewRequest.replace(':paymentType', 'withdrawal')} />
  </Route>,
  <PrivateRoute
    path={baseUrls.cashMovementNewRequest}
    exact={true}
    permissions={['cashMovementRequestsEnabled', 'achPullRequestsEnabled']}
    key="newCashMovement"
  >
    <NewCashMovementRequest />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.cashMovementBulkRequest} exact={true} permissions="bulkCashMovementRequestsEnabled" key="newCashMovementBulk">
    <CreateBulkCashMovementRequest />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.cashMovementRequest} exact={true} permissions="cashMovementRequestsEnabled" key="cashMovement">
    <CashMovementRequest />
  </PrivateRoute>,
  <PrivateRoute
    path={baseUrls.cashMovementNewRequestSubmitted}
    exact={true}
    permissions={['cashMovementRequestsEnabled', 'achPullRequestsEnabled']}
    key="createdCashMovement"
  >
    <CashMovementRequestCreated />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.cashMovementBulkSubmitted} exact={true} permissions="cashMovementRequestsEnabled" key="createdCashMovement">
    <CashMovementRequestCreated isBulk={true} />
  </PrivateRoute>
];

export default CmrRoutes;
